import {
  ChevronUp,
  PlusCircle,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import Brand from "../../../core/modals/inventory/brand";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../../Router/all_routes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setToogleHeader } from "../../../core/redux/action";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";

const Inventory = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [productlist, setProductlist] = useState([]);
  const columns = [
    // {
    //   header: "ID",
    //   accessorKey: "Id",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    // {
    //   header: "Facility",
    //   accessorKey: "Facility",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    {
      header: "Item Name",
      accessorKey: "Item_Type_Name",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "SKU Code",
      accessorKey: "Item_SkuCode",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Color",
      accessorKey: "Color",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Size",
      accessorKey: "Size",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Brand",
      accessorKey: "Brand",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Category",
      accessorKey: "Category_Name",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "MRP",
      accessorKey: "MRP",
      enableSorting: true,
      sortingFn: "numeric",
      Cell: ({ cell }) => `₹${cell.getValue()}`, // Custom cell rendering to add currency
    },
    {
      header: "Inventory",
      accessorKey: "Inventory",
      enableSorting: true,
      sortingFn: "numeric",
    },
    {
      header: "Inventory Blocked",
      accessorKey: "Inventory_Blocked",
      enableSorting: true,
      sortingFn: "numeric",
    },
    {
      header: "Bad Inventory",
      accessorKey: "Bad_Inventory",
      enableSorting: true,
      sortingFn: "numeric",
    },
    {
      header: "Putaway Pending",
      accessorKey: "Putaway_Pending",
      enableSorting: true,
      sortingFn: "numeric",
    },
    {
      header: "Cost Price",
      accessorKey: "Cost_Price",
      enableSorting: true,
      sortingFn: "numeric",
      Cell: ({ cell }) => `₹${cell.getValue()}`, // Custom cell rendering to add currency
    },
    {
      header: "Created Date",
      accessorKey: "CreatedDate",
      enableSorting: true,
      sortingFn: "datetime",
      Cell: ({ cell }) => new Date(cell.getValue()).toLocaleDateString(), // Format date
    },
    {
      header: "Updated Date",
      accessorKey: "UpdatedDate",
      enableSorting: true,
      sortingFn: "datetime",
      Cell: ({ cell }) => new Date(cell.getValue()).toLocaleDateString(), // Format date
    },
  ];

  console.log(productlist, "productlist p");
  console.log(columns, "productlist c");

  const route = all_routes;

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderPrinterTooltip = (props) => (
    <Tooltip id="printer-tooltip" {...props}>
      Printer
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: "inventory/inventorylist",
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setProductlist(response.ResponseData);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, []);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Inventory List</h4>
              <h6>Manage your Inventory</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                    onClick={() => {
                      showConfirmationAlert();
                    }}
                  />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <i data-feather="printer" className="feather-printer" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={renderRefreshTooltip}
                onClick={prodcutDataListApi}
              >
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            <Link to={route.inventorysync} className="btn btn-added">
              <PlusCircle className="me-2 iconsize" />
              Get Inventory Sync
            </Link>
          </div>
        </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            {/* <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${
                      isFilterVisible ? "setclose" : ""
                    }`}
                    id="filter_search"
                  >
                    <Filter
                      className="filter-icon"
                      onClick={toggleFilterVisibility}
                    />
                    <span onClick={toggleFilterVisibility}>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="img"
                      />
                    </span>
                  </Link>
                </div>
                <div className="form-sort">
                  <Sliders className="info-img" />
                  <Select
                    className="img-select"
                    classNamePrefix="react-select"
                    options={options}
                    placeholder="14 09 23"
                  />
                </div>
              </div> */}
            {/* /Filter */}
            {/* <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <div className="row">
                        <div className="col-lg-2 col-sm-6 col-12">
                          <div className="input-blocks">
                            <Box className="info-img" />
                            <Select
                              className="img-select"
                              classNamePrefix="react-select"
                              options={productlist}
                              placeholder="Choose Product"
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 col-sm-6 col-12">
                          <div className="input-blocks">
                            <StopCircle className="info-img" />
                            <Select
                              className="img-select"
                              classNamePrefix="react-select"
                              options={categorylist}
                              placeholder="Choose Category"
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 col-sm-6 col-12">
                          <div className="input-blocks">
                            <GitMerge className="info-img" />
                            <Select
                              className="img-select"
                              classNamePrefix="react-select"
                              options={subcategorylist}
                              placeholder="Choose Sub Category"
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 col-sm-6 col-12">
                          <div className="input-blocks">
                            <StopCircle className="info-img" />
                            <Select
                              className="img-select"
                              classNamePrefix="react-select"
                              options={brandlist}
                              placeholder="Nike"
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 col-sm-6 col-12">
                          <div className="input-blocks">
                            <i className="fas fa-money-bill info-img" />
  
                            <Select
                              className="img-select"
                              classNamePrefix="react-select"
                              options={price}
                              placeholder="Price"
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 col-sm-6 col-12">
                          <div className="input-blocks">
                            <Link className="btn btn-filters ms-auto">
                              {" "}
                              <i
                                data-feather="search"
                                className="feather-search"
                              />{" "}
                              Search{" "}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            {/* /Filter */}
            <div className="table-responsive">
              <CommonMaterialReactTable columns={columns} data={productlist} />
            </div>
          </div>
        </div>
        {/* /product list */}
        <Brand />
      </div>
    </div>
  );
};

export default Inventory;
